<mat-list class="mc-list-wrap">
  <mat-list-item *ngFor="let notification of notifications; trackBy: trackById" class="mc-notification-list-item">
    <mc-notification [notification]="notification"></mc-notification>
  </mat-list-item>
</mat-list>